/* eslint-disable import/first */
export * from '@gusiberi/shared'

import html2canvas from 'html2canvas'
import ImageCropper from './imageCropper'
import { getPresignedUrlRequest } from '@gusiberi/shared'

export const isMobile = (): boolean => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    window.navigator.userAgent
  )
}

export const setPageTitle = (title: string) => {
  const titleText = `${title} | Gusiberi`
  document.title = titleText
}

export const setCookie = (cookieName: string, cookieValue: string, exdays: number) => {
  const d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  const expires = 'expires=' + d.toUTCString()
  document.cookie = cookieName + '=' + cookieValue + ';' + expires + ';path=/'
}

export const getCookie = (cookieName: string) => {
  const name = cookieName + '='
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export const deleteCookie = (cookieName: string) => setCookie(cookieName, '', -1)

export const deleteAllCookies = () => {
  const cookies = document.cookie.split(';')
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i]
    const eqPos = cookie.indexOf('=')
    const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
  }
}

export const hasCookie = (cookieName: string) => !!getCookie(cookieName)

interface IUploadToS3 {
  filename: string
  fileUrl: string
  presignedUrl?: any
  imageElementsToRefresh?: any
  failSilently?: boolean
}

export const uploadToS3 = async ({
  filename,
  fileUrl,
  presignedUrl,
  failSilently,
}: IUploadToS3) => {
  try {
    const imageElement = await ImageCropper.createImage(fileUrl)
    const imageBlob = await ImageCropper.imageElementToBlob(imageElement)
    if (!imageBlob) {
      if (!failSilently) throw new Error('Failed to create image blob')
      return false
    }
    let url = presignedUrl
    if (!url) {
      const response = await getPresignedUrlRequest(filename)
      url =
        typeof response.payload === 'string'
          ? response.payload
          : response.payload?.url || response.url
    }
    await fetch(url, {
      method: 'PUT',
      body: imageBlob,
      headers: {
        'Content-Type': imageBlob.type,
      },
    })
    return true
  } catch (e) {
    if (!failSilently) throw e
    return false
  }
}

export const exportAsImage = async (element: HTMLElement | null, filename: string) => {
  if (!element) return
  const canvas = await html2canvas(element, { useCORS: true })
  const link = document.createElement('a')
  link.download = `${filename}.png`
  link.href = canvas.toDataURL()
  link.click()
}
